import React from 'react';
import { useParams } from 'react-router';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { isEmptyArr } from 'shared/utils/isEmpty';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { useDeleteBrandMutation, useGetBrandQuery } from 'features/useBrands';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { BrandFormWidget } from 'widgets/content/ui/BrandFormWidget';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const BrandDetailWidget = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const cities = useGetCitiesQuery({});
  const countries = useGetCountriesQuery(null);

  const brand = useGetBrandQuery({ id, language_id: 1 });
  const [deleteBrand] = useDeleteBrandMutation();

  if (brand.isFetching || countries.isFetching || cities.isFetching) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (brand.isError || countries.isError || cities.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  const onDeleteBrand = async (id: number) => {
    const data = await deleteBrand({ id });
    // @ts-ignore
    if (data && data.data === null) {
      navigate(-1);
    }
  };

  const getCountries = () => {
    if (brand.data.countries && countries.data) {
      return countries.data.filter((item) => brand.data.countries.includes(item.id)).map((item) => item.name);
    }
    return [];
  };

  const getCities = () => {
    if (brand.data.cities && cities.data) {
      return cities.data.filter((item: any) => brand.data.cities.includes(item.id)).map((item: any) => item.name);
    }
    return [];
  };

  return brand.isSuccess && countries.isSuccess && cities.isSuccess ? (
    <Box
      component={StyledCard}
      sx={{ marginBottom: '24px' }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 6 }}>
        <Typography variant="h6">{brand.data.title}</Typography>

        <Button
          color="error"
          variant="contained"
          onClick={() => {
            if (!isEmptyArr(brand.data.stories)) {
              toast.error('Удаление невозможно, у бренда есть сторисы', {
                position: toast.POSITION.TOP_RIGHT,
              });
              return;
            }
            onDeleteBrand(brand.data.id);
          }}
        >
          Удалить
        </Button>
      </Box>

      <Box style={{ display: 'flex', marginTop: '12px' }}>
        <div
          className="column"
          style={{ width: '250px' }}
        >
          <MoreInfo>
            <div className="title">ID</div>
            <div className="content">{brand.data.id}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Медиа</div>

            <div className="content">
              {brand.data.image ? (
                <Box
                  component="img"
                  src={brand.data.image}
                  sx={{ height: '140px', width: '140px', objectFit: 'cover' }}
                />
              ) : (
                '---'
              )}
            </div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px' }}
        >
          <MoreInfo>
            <div className="title">Направления</div>
            <div className="content">
              {!isEmptyArr(brand.data.directions) ? (
                <>{brand.data.directions.map((item: any) => item.title).join(', ')}</>
              ) : (
                '---'
              )}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Каналы B2B</div>
            <div className="content">
              {!isEmptyArr(brand.data.b2b_directions) ? (
                <>{brand.data.b2b_directions.map((item: any) => item.title).join(', ')}</>
              ) : (
                '---'
              )}
            </div>
          </MoreInfo>

          <MoreInfo>
            <div className="title">Уровни торговых точек</div>
            <div className="content">
              {!isEmptyArr(brand.data.b2b_tiers) ? (
                <>{brand.data.b2b_tiers.map((item: any) => item.title).join(', ')}</>
              ) : (
                '---'
              )}
            </div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px' }}
        >
          <MoreInfo>
            <div className="title">Страны</div>
            <div className="content">{getCountries() ? getCountries().join(', ') : '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Города</div>
            <div className="content">{getCities() ? getCities().join(', ') : '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Приоритет</div>
            <div className="content">{brand.data.priority || '---'}</div>
          </MoreInfo>
        </div>
      </Box>

      <BrandFormWidget
        refetch={brand.refetch}
        item={{ ...brand.data, countries_value: getCountries(), cities_value: getCities() }}
      />
    </Box>
  ) : null;
};
